import { render, staticRenderFns } from "./exhibition-product-home.vue?vue&type=template&id=6c6f817b&scoped=true&"
import script from "./exhibition-product-home.vue?vue&type=script&lang=js&"
export * from "./exhibition-product-home.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-product-home.vue?vue&type=style&index=0&id=6c6f817b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6f817b",
  null
  
)

export default component.exports